<template>
  <div>
    <base-header class="pb-6">
      <div class="row align-items-center py-4">
        <div class="col-lg-12">
          <h6 class="h2 text-white d-inline-block mb-0">Campo</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </div>
      </div>
    </base-header>
    <div v-if="isDataLoaded" class="container-fluid mt--6">
      <div class="row">
        <div class="col-md-12 col-sm-12">
          <field-data :field="field" />
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 col-sm-12">
          <plots-list :field="field.id" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb';
import FieldData from './Show/FieldData';
import PlotsList from './Show/PlotsList';

export default {
  name: 'FieldsShow',
  components: {
    RouteBreadCrumb,
    FieldData,
    PlotsList,
  },

  data() {
    return {
      isDataLoaded: false,
      field: null,
    };
  },

  mounted() {
    let fieldId = this.$route.params.id;
    this.fetchField(fieldId);
  },

  methods: {
    fetchField(id) {
      const params = {
        include: ['city.province', 'plotsCount', 'producer'],
      };
      this.$services
        .resource('fields')
        .show(id, params)
        .then((res) => res.data.data)
        .then((field) => {
          this.field = field;
          this.isDataLoaded = true;
        });
    },
  },
};
</script>
